import i18n from '@/plugins/i18n';
const connectionsMYGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.query-throughput'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_throughput',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.lock-wait-time'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_lock_waits_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.wait'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.total-queries'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_total_queries',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.slow-select-queries'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_total_select_queries_executed',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

// {
//   lineCharts: connectionsMYGraphs.lineCharts.map((chart) => ({
//     ...chart,
//     showmetricRate: true,
//   })),
// }

export default connectionsMYGraphs;
